import React, { useMemo } from 'react'
import classNames from 'classnames'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { CircleCloseIcon } from '@/atoms/Icons/CircleCloseIcon'
import { CaptionMD } from '@/atoms/Text'
import { formatNumberForDisplay } from '@/utils/numbers'
import { useTranslate } from '@/utils/translate/translate-client'
import { PerkItemProps } from '../PerkTypes'

export const PerkItem: React.FC<PerkItemProps> = ({ perk, projectName, quantity, isActive }) => {
  const { t } = useTranslate('pif')

  const perkText = useMemo(() => {
    if (typeof perk !== 'string') {
      let text = perk.name

      if (perk?.product?.pif && quantity) {
        text = t('payItForwardForPeople', {
          count: quantity,
          defaultValue_one: '{{quantity}} person can watch {{projectName}} for free',
          defaultValue_other: '{{quantity}} people can watch {{projectName}} for free',
          projectName,
          quantity: formatNumberForDisplay({ count: quantity, format: '0[.]0a' }),
        })
      }
      return text
    } else {
      return perk
    }
  }, [perk, projectName, quantity, t])

  const getPerkColor = (isActive: boolean) => (isActive ? 'core-oxide' : 'gray-500')
  const color = getPerkColor(!!isActive)

  return (
    <div className="flex items-start gap-2">
      <div className="my-0.5 h-4 w-4">
        {isActive ? (
          <CircleCheckIcon color1={color} color2="white" size={16} />
        ) : (
          <CircleCloseIcon color={color} size={16} />
        )}
      </div>
      <CaptionMD
        className={classNames('my-0', {
          'text-gray-500': color === 'gray-500',
        })}
      >
        {perkText}
      </CaptionMD>
    </div>
  )
}
